export default {"src":"/_next/static/image/public/images/ic_bookmark.dbb4aff6fd90d6e47bb70925e0706221.svg","height":18,"width":14};